import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { lazy, Suspense, useEffect } from "react";
import { Route, Switch } from "react-router";
import ErrorBoundary from "./components/ErrorBoundary";
import { useAppDispatch } from "./utils/hooks";
import { loadSettings } from "./redux/slices/settingsSlice";
import { keys } from "./apis";
import Footer from "./components/Footer";
import { localeData } from "./data/locale";
import Header from "./components/Header";
// images
import headerLogo from "./images/cont-logo.png";
import footerLogo from "./images/cont-footer-logo.png";
// pages
const Landing = lazy(() => import("./pages/Landing"));
const News = lazy(() => import("./pages/News"));
const Works = lazy(() => import("./pages/Works"));

const headerNav = [
  {
    path: "/",
    exact: true,
    name: localeData.home,
  },
  {
    path: "/contracting#about",
    exact: false,
    name: localeData.about,
  },
  {
    path: "/contracting#news",
    exact: false,
    name: localeData.news,
  },
  {
    path: "/contracting#works",
    exact: false,
    name: localeData.work,
  },
  {
    path: "/contracting#partners",
    exact: false,
    name: localeData.partners,
  },
  {
    path: "/contracting#certificates",
    exact: false,
    name: localeData.certificates,
  },
  {
    path: "/contracting#branches",
    exact: false,
    name: localeData.branches,
  },
  {
    path: "/jobs",
    exact: false,
    name: localeData.jobs,
  },
];

const footerNav = [
  {
    path: "/contracting",
    name: localeData.cont,
  },
  {
    path: "/equipments",
    name: localeData.equipments,
    exact: true,
  },
  {
    path: "/transport",
    name: localeData.transport,
  },
  {
    path: "/",
    exact: true,
    name: localeData.home,
  },
  {
    path: "/contracting#about",
    exact: false,
    name: localeData.about,
  },
  {
    path: "/contracting#news",
    exact: false,
    name: localeData.news,
  },
  {
    path: "/contracting#works",
    exact: false,
    name: localeData.work,
  },
  {
    path: "/contracting#branches",
    exact: false,
    name: localeData.branches,
  },
  {
    path: "/jobs",
    exact: false,
    name: localeData.jobs,
  },
];

function Contracting() {
  const dispatch = useAppDispatch();

  // mount logic
  useEffect(() => {
    dispatch(loadSettings(keys.cont));
    document.title = localeData.cont;
  }, []); // eslint-disable-line

  return (
    <>
      <Header logo={headerLogo} homePath="/contracting" nav={headerNav} siteKey={keys.cont} />
      <Suspense
        fallback={
          <div className="text-center page-placeholder">
            <Spin
              indicator={<LoadingOutlined style={{ fontSize: "28px" }} />}
            />
          </div>
        }
      >
        <Switch>
          <Route path="/contracting" exact={true}>
            <ErrorBoundary>
              <Landing siteKey={keys.cont} />
            </ErrorBoundary>
          </Route>
          <Route path="/contracting/news/:id">
            <ErrorBoundary>
              <News />
            </ErrorBoundary>
          </Route>
          <Route path="/contracting/works">
            <ErrorBoundary>
              <Works />
            </ErrorBoundary>
          </Route>
        </Switch>
      </Suspense>
      <Footer logo={footerLogo} navItems={footerNav} siteKey={keys.cont} />
    </>
  );
}

export default Contracting;
